import { makeAutoObservable } from 'mobx'
import { type ITabItem } from 'shared/ui'

type IIntegrationsPageTabKey = 'integrations' | 'automationLogs'

export class IntegrationsPageStore {
  private _activeTabKey: IIntegrationsPageTabKey = 'integrations'

  constructor() {
    makeAutoObservable(this)
  }

  get activeTabKey() {
    return this._activeTabKey
  }

  get tabs() {
    const tabs = [
      {
        key: 'integrations',
        name: 'Integrations',
      },
      {
        key: 'automationLogs',
        name: 'Automation Logs',
        statusProps: {
          title: 'New',
          intent: 'purple',
          emphasis: 'high',
          size: 'label',
        },
      },
    ] as ITabItem<IIntegrationsPageTabKey>[]

    return tabs
  }

  setActiveTab = (tab: ITabItem<IIntegrationsPageTabKey>) => {
    this._activeTabKey = tab.key
  }
}
